import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class XlsxLoaderService {
    private xlsxModulePromise: Promise<typeof import('xlsx')> | null = null;

    constructor() { }

    getXlsxModule(): Promise<typeof import('xlsx')> {
        if (!this.xlsxModulePromise) {
            this.xlsxModulePromise = import('xlsx');
        }
        return this.xlsxModulePromise;
    }
}
